// 关于与帮助：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 关于和帮助
export const ui = Object.freeze({
  "pcAbout.about": "关于先搜",
  "pcAbout.contact": "联系我们",
  "pcAbout.join": "加入我们",
  "pcAbout.privacy": "隐私说明",
  "pcAbout.help": "帮助中心",
  "pcAbout.companyAlt": "先搜科技",
  "pcAbout.value1": "理念",
  "pcAbout.value1Desc": "以客户为中心，卓越服务",
  "pcAbout.value2": "精神",
  "pcAbout.value2Desc": "以奋斗为根本，持续创造",
  "pcAbout.value3": "责任",
  "pcAbout.value3Desc": "以行业为己任，协作共赢",
  "pcAbout.value4": "目标",
  "pcAbout.value4Desc": "以诚信为基石，价值共享",
  "pcAbout.onlineMessage": "在线留言",
  "pcAbout.name": "姓名",
  "pcAbout.phone": "电话",
  "pcAbout.email": "邮箱",
  "pcAbout.message": "留言内容",
  "pcAbout.enterName": "请输入您的姓名",
  "pcAbout.enterPhone": "请输入您的联系电话",
  "pcAbout.enterEmail": "请输入您的邮箱",
  "pcAbout.enterMessage": "请输入您的留言内容",
  "pcAbout.nameMax": "姓名不能超过50个字符",
  "pcAbout.phoneMax": "联系电话不能超过30个字符",
  "pcAbout.invalidEmail": "请输入正确的邮箱格式",
  "pcAbout.emailMax": "邮箱不能超过100个字符",
  "pcAbout.messageMax": "留言内容不能超过1000个字符",
  "pcAbout.submit": "提交留言",
  "pcAbout.responsibilities": "岗位职责",
  "pcAbout.requirements": "任职要求",
  "pcAbout.apply": "立即申请",
  "pcAbout.helpSearch": "搜索帮助文档，输入关键词...",
  "pcAbout.hotSearch": "热门搜索：",
  "pcAbout.moreQuestions": "还有其他问题？",
  "pcAbout.contactHelp": "联系我们的客服团队，我们将为您提供专业的帮助",
  "pcAbout.contactSupport": "联系客服",
  "pcAbout.close": "关闭",
  "pcAbout.pageTitle": "关于我们 - 先搜科技",
  "pcAbout.fallbackTitle": "关于我们",
  "pcAbout.address": "公司地址",
  "pcAbout.contactPhone": "联系电话",
  "pcAbout.contactEmail": "电子邮箱",
  "pcAbout.hours": "工作时间",
  "pcAbout.weekdays": "周一至周五 9:00-18:00",
  "pcAbout.addressValue": "深圳市南山区侨香路4060号704B",
  "pcAbout.submitted": "留言提交成功，我们会尽快联系您",
  "pcAbout.submitFailed": "留言提交失败，请稍后重试",
  "pcAbout.content.about_xsou":
    '<p>深圳先搜科技有限公司成立于 2017 年 8 月 24 日，专注半导体存储芯片领域，是国内领先的存储芯片供应链综合服务平台，致力打造中国半导体芯片供应链第一品牌，以 "改善半导体芯片全产业链营商环境" 为使命，为行业提供金流、物流、信息流 "三流合一" 的一站式解决方案。</p><p>公司深耕存储行业上下游资源整合，凭借专业供应链能力与金融服务，为客户提供高效、安全、低成本的产业服务，已与三星、美光、海力士、英特尔、长江存储等全球一线原厂及国内知名品牌厂商建立长期稳定合作，成为存储行业值得信赖的供应链合作伙伴。</p>',
  "pcAbout.content.contact":
    "<p>公司地址：深圳市南山区侨香路4060号704B</p><p>联系电话：400-966-2855</p><p>电子邮箱：fengke@xsou.com</p><p>工作时间：周一至周五 9:00-18:00</p>",
  "pcAbout.content.join":
    "<p>先搜科技正在快速发展，我们期待有才华、有激情的你加入我们的团队！在这里，你将获得广阔的发展空间和良好的职业发展机会。</p>",
  "pcAbout.content.privacy":
    "<h3>1. 隐私政策概述</h3><p>深圳先搜科技有限公司（以下简称“先搜科技”或“我们”）非常重视用户隐私和数据保护。本隐私政策旨在说明我们如何收集、使用、存储和保护您的个人信息。</p><h3>2. 信息收集</h3><p>我们可能会收集您在使用我们服务过程中提供的个人信息，包括但不限于：姓名、联系方式、公司信息、浏览记录、交易信息等。</p><h3>3. 信息使用</h3><p>我们收集的信息将用于：提供和改进服务、处理交易、客户服务、安全保障、市场调研等。我们不会向第三方出售您的个人信息。</p><h3>4. 信息保护</h3><p>我们采用业界领先的安全技术和措施来保护您的信息安全，包括数据加密、访问控制、安全审计等。</p><h3>5. 用户权利</h3><p>您有权访问、更正、删除您的个人信息，也可以随时撤回您的授权。如需帮助，请联系我们的客服团队。</p><h3>6. 政策更新</h3><p>我们可能会不定期更新本隐私政策，更新后的政策将在网站上发布。您的持续使用视为同意更新后的政策。</p>",
  "pcAbout.content.help":
    "<p>如在注册登录、订单查询、物流跟踪、售后服务、发票申请等环节遇到问题，可通过客服渠道联系我们。</p>",
});

export const messages = Object.freeze({ ...ui });
